import React, { useState, useEffect } from 'react'
import '../../fonts/fonts.css'
import SideBar from '../SideBar'
import { connect, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { compose } from 'redux'
import pdfMake from 'pdfmake/build/pdfmake'
import Menu from '../../images/menuBoxed.svg'
import MainTitle from '../../components/MainTitle'
import pen from '../../images/pen.svg'
import ArrowDown from '../../images/ArrowDownSelector.svg'
import { Selector, Opt, SelectorJourney, ProgressionBarIn, PrintContainer, Print, Bg, MainLayout, ArrowStudent, ArrowJourney, ProgressionBar, SelectorContainer, Info, InfoContainer, Stats, Parcours, TotalStats, TotalStatsContainer, TotalStatsPercent, AllStats } from './styledComponents'

const PlayerStats = () => {
  const location = useLocation()
  const history = useHistory()

  const players = useSelector((state) => state.toJS().global.players)
  const journeys = useSelector((state) => state.toJS().global.journeys)
  const sequences = useSelector((state) => state.toJS().global.sequencesRaw)
  const progressions = useSelector((state) => state.toJS().global.progressions)

  const id = location.query ? location.query.id : location.pathname.split('/')[4]
  const player = players ? players.find((player) => player.id.toString() === id) : ''
  const playerJourneys = player.journeys || ''
  const journeysTitle = journeys.find((journeys) => journeys.id.toString() === playerJourneys.toString()).title || ''

  const [borderBottom, setBorderBottom] = useState([' ', ' ', ' '])
  const [colors, setColors] = useState([' ', ' ', ' '])
  const [totalStats, setTotalStats] = useState()
  const [stateStats, setStateStats] = useState()
  const [printable, setPrintable] = useState(false)

  useEffect(() => {
    setStateStats(stats())
    // eslint-disable-next-line
  }, [location])

  function createPDF () {
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [63, 51, 0, 0],
      content: [
        {
          image: 'data:image/png;base64,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',
          alignment: 'left' // Default... not actually required.
        },
        {
          text: 'Nom de la formation :',
          style: 'header'
        },
        [
          { text: journeysTitle, fontSize: 16 }
        ],
        {
          text: 'Nom de l\'élève :',
          style: 'subheader'
        },
        [
          { text: player.lastname + ' ' + player.firstname, fontSize: 16, listType: 'none', margin: [0, 0, 0, 0] }
        ],
        {
          style: 'form',
          text: 'Vous venez de terminer avec brio une formation de sensibilisation aux risques routiers.\nCette formation répond aux spécificités des normes officielles et vous offre une certification Qualiopi.\nMerci et bravo pour votre participation !'
        },
        {
          style: 'prog',
          decoration: 'underline',
          text: 'Le programme :'
        },
        {
          style: 'list',
          separator: '- ',
          ol:
      statsForPdf()
        },
        {
          absolutePosition: { x: 66, y: 514 },
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 200,
              w: 133,
              h: 70,
              r: 6,
              lineColor: 'black'
            }
          ]
        },
        {
          style: 'tableAgence',
          table: {
            body: [
              [{ text: 'Cachet de l\'agence :' }]
            ]
          },
          layout: 'headerLineOnly',
          absolutePosition: { x: 75, y: 718 }
        },
        {
          absolutePosition: { x: 66, y: 789 },
          canvas: [
            {
              type: 'rect',
              x: 145,
              y: -75,
              w: 133,
              h: 70,
              r: 6,
              lineColor: 'black'
            }
          ]
	    },
        {
          style: 'tableSignature',
          table: {
            body: [
              [{ text: 'Signature de l\'élève :' }]
            ]
          },
          layout: 'headerLineOnly',
          absolutePosition: { x: 220, y: 718 }
        },
        {
          absolutePosition: { x: 66, y: 789 },
          canvas: [
            {
              type: 'rect',
              x: 290,
              y: -75,
              w: 133,
              h: 70,
              r: 6,
              lineColor: 'black'
            }
          ]
	    },
        {
          style: 'tableCachet',
          table: {
            body: [
              [{ text: 'Cachet de l\'organisme \nde formation :' }]
            ]
          },
          layout: 'headerLineOnly',
          absolutePosition: { x: 370, y: 718 }
        },
        {
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAhCAYAAACr8emlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUSSURBVHgB7VjdbeNGEJ6VKMMPF0SPCWA7VAX2VRC6gtgVnJgGLFdwUgW5q4ByBbErEFOB7QrEWAfk0fRDACOWuPlmf8QluZSYIEAQIAOtRA5nZr+dHc7OSFCyktSdcozPRMGc4m8zSp4uiMQVRuYXl2dE63OKRzklX3BdTCD7gbqSoDToLKxA9M8VsJJ+AoBLAHjwqiSrKdEAMhRTfMQyYyzqFrYSXA+pA/WoE3nAJU9jpd4GTusBjASo38ItKz5hgOekd+OfAOj1HNNHUtu9g7TXMNaTJl9eUwcS+2NQXupVO5SsInwvSHlB7vGECLXceqRisWpnSnqhbej2xuCsAU6DRvyIGcZ3uAkxIo8ug0khg7F5ITocUn1b4+MpQJ7i6oJaMbZ7cKYMdKHkaWk85dIt9C/36y4BPODdOKMmurQN4G5waovlD7BwZgy3vZEcgxwG+B189sSxC5Lf7Is6wMBj8BrgUtpNiBsR0X4yXmHZzSMu5l4pHZuXOjMo26F9FFikVIg5/Xh0Q51I/spKGO/xhsP4a958AWxq2cArErmw2J9W4pM5vJkC1hg6H/Qc+o38a5QsQ7PaLrJDJevmws7z/A1s/9N/jfqHhxQGAQ3teLcG95C+Wa/LpMoyfO/Kstyr+pQ05E9N1+r75K1d955tV/QHgqQ7Dno05d9DfUJsZfi+Jpe4wMBbOM+XA6QYNfha0LPRUcfaQZ8uAs2r8Cv2Bf1MNr8CdcQT1AH5ALr87fMeTWDwfmgM9pFwDejlAdFUeUfrPyOvRWYBqoAwi+DDYmh+rewCdj+1AjQescP1oOY5R5O676PW02ATvmcv2QktwVNzu0OVBWJxBviWz/bYTmuxUEi6QZrM+FqIshiw/HcY20AR9Cik9qws8LxHY6m9mfPEa1U04Jmk7wFhAfmcF4yAzPh34zsqIYt5XloBwkPpqwE4cPg9Qapk/13gWCxI1XT9gj4V7DVBpxKTw/ipKOgWIGeC+aSuzzBh/gfRTSBptNH8B4CPsLg7XsTA7AYxYCy4J+m9MPMOETfRhisQUjE0Nte5e9+vHua5lWdiT7yZwoE9bL1m+JHLY2LPAnTo8nkea/sr8PKOVfe/SqJ2pgKx4Or3oXL489lL/aimmjXllC3cb1LIa29zAVCn0l6uCuLWc11kgemwagR28mVO9HatAbCxNjmU7fHxzBhMFPD4ZIRJddmUrLJm+WbtoYJSYeKzTfV6UAmDZEiqhEc3RgFfn7srom0ccdmvYpLL9l+aIASXbh+NTP2Z6Y2LO4eZ6y7QFZNZCTA+irfXaguCewVUV8/2SVqVW3EivSLdk6QV47SewwYDZDCTqm2WZ08fO4AQWq5tQ/62Mx5l+LbFa2tDQ7veMm0jJU4ZlbpuG8tpQ4drRneQrai9xH2Eqpq/Lj0onUJVdXRXpayPBLZQRkYuNUzTZspa9c6htV46uhm+RjsAitAovjjMqNmLYCJva8r0NjfbHJnGiPNkqLf3KPUouLyMv/wAlTHTE0hxj2C1CZ09ZQMbXR0Ss+wtqI3Un0Yr9hQ8GEy01yV/pk1hBfq8zi0BlrnINNIiVErcSJXbirx3NNXyq5RInat4i5d3jaappFsNkIdq+DN/cyaHzXwoMjfNVHMRd3qyH1MbcVpRIDnG2Ds+r7hy24IjbbE49GFggLOa4DPGI43dvNbjP3sgV9ReBoFiQV7o00cR2/J40sox9efN5w0Mmgqx/BM5gA4f5MNy/gAAAABJRU5ErkJggg==',
          absolutePosition: { x: 525, y: 747 }
        }
      ],
      styles: {
        header: {
          fontSize: 12,
          bold: true,
          margin: [0, 35, 0, 5]
        },
        subheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 30, 0, 5]

        },
        list: {
          margin: [0, 30, 0, 0],
          lineHeight: 2
        },
        tableAgence: {
          fontSize: 9
        },
        tableSignature: {
          fontSize: 9
        },
        tableCachet: {
          fontSize: 9
        },
        form: {
          margin: [0, 15, 0, 0]
        },
        prog: {
          margin: [0, 15, 0, 0],
          fontSize: 14,
          lineHeight: 1.5
        }
      }
    }
    pdfMake.createPdf(docDefinition).download()
  }

  // switch color in the infoContainer to know where we are
  function onClickColor (e) {
    setColors([
      e === 0 ? '#166DD8' : 'black',
      e === 1 ? '#166DD8' : 'black',
      e === 2 ? '#166DD8' : 'black'
    ])
    setBorderBottom([
      e === 0 ? '3px solid #166DD8' : 'black',
      e === 1 ? '3px solid #166DD8' : 'black',
      e === 2 ? '3px solid #166DD8' : 'black'
    ])
  }

  function handleChange (e) {
    history.push(`/players/edit/stats/${e.target.value}`)
  }

  function displaySelector () {
    if (players) {
      return (
        <Selector style={{ marginTop: '4rem' }} onChange={(e) => { handleChange(e) }} value={id}>
          {players.map((pl, i = 0) => {
            if (pl.foreignKey === 'fkeditor') { return null } // this is how to "hide" the editor
            return (
              <Opt key={i} value={pl.id}>{pl.firstname + ' ' + pl.lastname}</Opt>
            )
          })}
        </Selector>
      )
    }
  }

  function handleChangejourneySelector (e) {
    // const newjourney = journeys.find( // TODO: Work on it for multi-parcours
    //   (journeys) => journeys.id.toString() === e.target.value.toString()
    // )
  }

  function displayJourneySelector () {
    if (journeys) {
      return (
        <SelectorJourney
          style={{ marginTop: '2.4rem' }}
          onChange={(e) => {
            handleChangejourneySelector(e)
          }}
          value={id}
        >
          <Opt>{journeysTitle}</Opt>
        </SelectorJourney>
      )
    }
  }

  // Compare player journey id with journeys ids.
  function getSequenceIdWithPlayerJourney () {
    const seqIds = []
    journeys.forEach((j) => {
      if (j.id.toString() === playerJourneys.toString()) {
        seqIds.push(j.sequences)
      }
    })
    return seqIds
  }

  function statsForPdf () {
    const playerSequences = getSequenceIdWithPlayerJourney()[0]
    const allSequences = sequences
    const TableauT = []
    allSequences.forEach((sq) => {
      if (playerSequences.includes(sq.id.toString())) {
        TableauT.push({ text: sq.title + ' - 100%' })
      }
    })
    return (
      TableauT
    )
  }
  // render of the sequences stats
  function stats () {
    const playerSequences = getSequenceIdWithPlayerJourney()[0]
    const playerProgression = getPlayerProgression()
    let totalSeq = 0
    let scoreTotal = 0
    let totalStats = 0

    return sequences.map((sq, index) => {
      if (playerSequences.includes(sq.id.toString())) {
        let score = 0
        let totalScore = 0
        if (sq !== undefined) {
          totalSeq++
        }
        if (playerProgression.length !== 0) {
          for (let i = 0; i < playerProgression.length; i++) {
            if (playerProgression[i].progId === sq.id.toString()) {
              totalScore = playerProgression[i].progScore.reduce(
                (a, v) => (v.containsScore ? a + 1 : a),
                0
              )
              for (let s = 0; s < playerProgression[i].progScore.length; s++) {
                if (
                  playerProgression[i].progScore[s].score != null &&
                  playerProgression[i].progScore[s].containsScore
                ) {
                  score++
                }
              }
            }
          }
        }
        if ((score * 100) / totalScore === 100) {
          scoreTotal++
        }
        return (
          <div key={index}>
            <div
              style={{ marginLeft: '1.5rem', textAlign: 'left', marginBottom: '-2.5rem', marginTop: '1rem' }}
            >
              {sq.title + ' '}
            </div>
            <div
              style={{ color: '#024179', fontSize: '1rem', textAlign: 'right', marginBottom: '0.4rem', marginRight: '2rem', marginTop: '1rem', fontWeight: '700' }}
            >
              {(totalScore ? (score * 100) / totalScore : 0).toFixed(0) + '%'}
            </div>
            <ProgressionBar>
              <ProgressionBarIn
                style={{
                  width: `${totalScore ? (score * 100) / totalScore : 0}%`
                }}
              />
            </ProgressionBar>
          </div>
        )
      }
      totalStats = (scoreTotal * 100 / totalSeq).toFixed(0)
      if (index === sequences.length - 1) { return (setTotalStats(totalStats), totalStats === '100' ? setPrintable(true) : setPrintable(false)) } else {
        return null
      }
    })
  }

  // For each progression, look if id match with player then simplify the object.

  function getPlayerProgression () {
    const progP = []
    progressions.forEach((prog) => {
      if (prog.playerId === id) {
        progP.push({ progId: prog.sequenceId, progScore: prog.sectionScores })
      }
    })
    return progP
  }

  function renderPrintFeature () {
    if (printable) {
      return (
        <PrintContainer>
          <Print onClick={() => createPDF()}>
            <img alt='' src={Menu} />
            Obtenir le certificat
          </Print>
        </PrintContainer>
      )
    }
  }

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <MainTitle text='Le compte élève' icon={pen} />
        <SelectorContainer>
          <ArrowStudent src={ArrowDown} />
          {displaySelector()}
        </SelectorContainer>
        <InfoContainer>
          <Info
            to={`/players/edit/${id}`}
            style={{
              color: colors[0],
              borderBottom: borderBottom[0]
            }}
            onClick={(e) => onClickColor(0)}
          >
            Informations
          </Info>
          <Parcours
            style={{
              color: colors[1],
              borderBottom: borderBottom[1]
            }}
            onClick={(e) => onClickColor(1)}
          >
            Parcours
          </Parcours>
          <Stats
            style={{
              color: colors[2],
              borderBottom: borderBottom[2]
            }}
            onClick={(e) => onClickColor(2)}
          >
            Statistiques
          </Stats>
        </InfoContainer>
        <SelectorContainer>
          <ArrowJourney src={ArrowDown} />
          {displayJourneySelector()}
        </SelectorContainer>
        <TotalStatsContainer>
          <TotalStats>
            {totalStats}
            <TotalStatsPercent>%</TotalStatsPercent>
          </TotalStats>
        </TotalStatsContainer>
        <AllStats>
          <div>{stateStats}</div>
        </AllStats>
        {renderPrintFeature()}
      </MainLayout>
    </Bg>
  )
}

const withConnect = connect(null)
const arg = compose(withConnect)(PlayerStats)

export default withConnect(arg)
